import { IState } from '../../store';

export const selectBookingLandingUrl = (state: IState): string => {
  return state.newbuildingBooking.landingUrl;
};
